var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{attrs:{"id":"elliptischeFlagge","title":"rumänische Flagge"}}),_c('div',{attrs:{"id":"flagge","title":"rumänische Flagge"}}),_c('TopNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }